import { render, staticRenderFns } from "./ManageProcess.vue?vue&type=template&id=4054721f"
import script from "./ManageProcess.vue?vue&type=script&lang=js"
export * from "./ManageProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports